var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import Icon from "./Icon";
import { Flex } from "./grid";
import React, { useRef } from 'react';
import { space, flexbox } from 'styled-system';
import { styled, css } from "../utils";
var Arrow = styled(Icon.ArrowLeft)(function (_a) {
    var isRight = _a.isRight;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      cursor: pointer;\n      transform: ", ";\n    "], ["\n      cursor: pointer;\n      transform: ", ";\n    "])), isRight ? 'rotateY(-180deg)' : 'unset');
}, space, flexbox);
var ThumbnailsContainer = styled.div(function (_a) {
    var space = _a.theme.space;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    width: 100%;\n    padding-right: ", ";\n    padding-left: ", ";\n    height: auto;\n    display: flex;\n    flex-wrap: nowrap;\n    overflow: hidden;\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n  "], ["\n    position: relative;\n    width: 100%;\n    padding-right: ", ";\n    padding-left: ", ";\n    height: auto;\n    display: flex;\n    flex-wrap: nowrap;\n    overflow: hidden;\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n  "])), space[6], space[6]);
});
var Thumbnail = styled.img(function (_a) {
    var selected = _a.selected, hasMarginRight = _a.hasMarginRight, hasMarginLeft = _a.hasMarginLeft, aspectRatio = _a.aspectRatio, _b = _a.theme, colors = _b.colors, space = _b.space;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    height: ", ";\n    cursor: pointer;\n    width: 100%;\n    aspect-ratio: ", ";\n    border: ", ";\n    object-fit: cover;\n    margin-right: ", ";\n    margin-left: ", ";\n  "], ["\n    height: ", ";\n    cursor: pointer;\n    width: 100%;\n    aspect-ratio: ", ";\n    border: ", ";\n    object-fit: cover;\n    margin-right: ", ";\n    margin-left: ", ";\n  "])), selected ? '140px' : '150px', aspectRatio, selected ? "solid 5px ".concat(colors.primary) : 'none', hasMarginRight ? '0' : space[1], hasMarginLeft ? '0' : space[1]);
});
var Thumbnails = function (_a) {
    var pictures = _a.pictures, _b = _a.withArrows, withArrows = _b === void 0 ? true : _b, setCurrentImageIndex = _a.setCurrentImageIndex, currentImageIndex = _a.currentImageIndex, aspectRatio = _a.aspectRatio;
    var scrollImagesRef = useRef(null);
    var touchStartX = useRef(0);
    var touchEndX = useRef(0);
    var handleTouchStart = function (e) {
        touchStartX.current = e.touches[0].clientX;
    };
    var handleTouchMove = function (e) {
        touchEndX.current = e.touches[0].clientX;
    };
    var handleTouchEnd = function () {
        if (touchStartX.current - touchEndX.current > 75) {
            navigateImages('right');
        }
        if (touchEndX.current - touchStartX.current > 75) {
            navigateImages('left');
        }
    };
    var scrollToImagePosition = function (index) {
        var _a;
        var images = (_a = scrollImagesRef.current) === null || _a === void 0 ? void 0 : _a.children;
        if (!images || images.length === 0) {
            return;
        }
        var cumulativeWidthBeforeSelected = Array.from(images).reduce(function (acc, curr, i) { return (i < index ? acc + curr.clientWidth : acc); }, 0);
        var selectedImageWidth = images[index].clientWidth;
        var containerWidth = scrollImagesRef.current.clientWidth;
        var imageCenter = cumulativeWidthBeforeSelected + selectedImageWidth / 2;
        var scrollPosition = imageCenter - containerWidth / 2;
        scrollImagesRef.current.scrollTo({
            left: scrollPosition > 0 ? scrollPosition : 0,
            behavior: 'smooth',
        });
    };
    var selectImage = function (index) {
        setCurrentImageIndex(index);
        scrollToImagePosition(index);
    };
    var navigateImages = function (direction) {
        var newIndex = direction === 'left'
            ? Math.max(0, currentImageIndex - 1)
            : Math.min(pictures.length - 1, currentImageIndex + 1);
        setCurrentImageIndex(newIndex);
        scrollToImagePosition(newIndex);
    };
    return (React.createElement(Flex, { width: 1, mt: "small", mb: "normal", alignItems: "center" },
        withArrows && React.createElement(Arrow, { px: "large", onClick: function () { return navigateImages('left'); } }),
        React.createElement(ThumbnailsContainer, { ref: scrollImagesRef, onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, onTouchEnd: handleTouchEnd }, pictures.map(function (picture, index) { return (React.createElement(Thumbnail, { key: index, src: picture, alt: "product-".concat(index), onClick: function () { return selectImage(index); }, selected: currentImageIndex === index, hasMarginRight: index === pictures.length - 1, hasMarginLeft: index === 0, aspectRatio: aspectRatio })); })),
        withArrows && React.createElement(Arrow, { isRight: true, px: "large", onClick: function () { return navigateImages('right'); } })));
};
export default Thumbnails;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Thumbnails.js.map